import React, {useState} from 'react';
import {Button} from 'antd';
import SnakeGame from "./snake-game";
import '../../styles/component/no-internet-page.scss';
import {CloseOutlined} from "@ant-design/icons";

const NoInternetPage = () => {
    const [playGame, setPlayGame] = useState(false)
    const HandlePlayGame = () => {
        setPlayGame(true);
    }

    return (
        <div className="no-internet-page">
            <div className="no-internet-card">
                <div className="icon-wrapper">
                    <div className="icon-ring">
                        <div className="signal-bars">
                            <div className="bar bar--1 on"/>
                            <div className="bar bar--2 on"/>
                            <div className="bar bar--3"/>
                            <div className="bar bar--4"/>
                        </div>
                    </div>
                    <div className="error-badge">
                        <CloseOutlined/>
                    </div>
                </div>

                <h2 className="no-internet-title">
                    You're Offline !!
                </h2>
                <p className="no-internet-desc">
                    We’re unable to connect right now. Please check your network — or play a quick game while you wait.
                </p>

                <div className="btn-row">
                    <Button onClick={() => window.location.reload()}> Retry</Button>
                    {!playGame &&
                    <Button
                        onClick={() => HandlePlayGame()}>
                        Play Offline Game
                    </Button>

                    }
                </div>
            </div>
            {
                playGame && <div>
                    <SnakeGame/>
                </div>
            }

        </div>
    );
};


export default NoInternetPage;